import request from '@/utils/request';

export function getComboList(options, silentRequest = false) {
  const params = Object.assign({
    targetId: 0,
  }, options);
  return request({
    url: '/Combo/explore',
    params,
    silentRequest,
  });
}

export function getComboDetail(id) {
  return request({
    url: 'Combo/getComboDetail',
    params: {
      id,
    },
  });
}

export function getAudioComboDetail(id) {
  return request({
    url: '/Combo/getAudioComboDetail',
    params: {
      id,
    },
  });
}

export function getCourseComboDetail(id) {
  return request({
    url: '/Combo/getCourseComboDetail',
    params: {
      id,
    },
  });
}

export function getMultiComboDetail(id) {
  return request({
    url: '/Combo/getMultiComboDetail',
    params: {
      id,
    },
  });
}

export function getComboIntroductionInfo(id) {
  return request({
    url: '/Combo/introduction',
    params: {
      id,
    },
  });
}
